@use '@/styles/tokens' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.dragger {
  :global(.ant-upload) {
    border-radius: 10px;
    // Figma 944:564552 — the dropzone is a white card with a subtle dashed rule, not antd's
    // default grey fill.
    background: var(--surface-card);
    border-color: var(--border-subtle);
  }
}

.error :global(.ant-upload.ant-upload-drag) {
  border-color: $color-error-900;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  // Figma 944:564552 draws the empty container at exactly 155px tall.
  min-height: 155px;
  padding: var(--space-6);
  color: var(--text-muted);
}

.filled {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  padding: var(--space-4);
}

.help {
  margin: 0;
  font-size: 14px;
  text-align: center;
  white-space: pre-line;
}

.grid {
  display: grid;
  // Figma 430:405299 lays four tiles across the panel's 406px content width.
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-4);
}

.more {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
}

.counter {
  display: flex;
  align-items: center;
  // The scale has no 3px step; Figma's 3 rounds to the 4px token.
  gap: var(--space-1);
  margin: 0;
  font-size: $font-size-11;
  color: var(--text-muted);

  > svg {
    color: $color-success-900;
  }
}

.tile {
  position: relative;
  aspect-ratio: 1;
  overflow: hidden;
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
  background: var(--surface-muted);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.tileRemove {
  position: absolute;
  top: 4px;
  right: 4px;
}

.tileLoading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: var(--text-muted);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
}

.rowIcon {
  flex-shrink: 0;
  color: var(--text-secondary);
}

.rowBody {
  flex: 1 0 0;
  min-width: 0;
}

.rowName {
  font-size: 14px;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowMeta {
  font-size: 12px;
  color: var(--text-muted);
}

.bar {
  height: 4px;
  margin-top: 6px;
  border-radius: 999px;
  background: var(--surface-muted);

  span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: $color-neutral-950;
    transition: width 0.2s ease;
  }
}

.rowError {
  font-size: 12px;
  color: $color-error-900;
}

.retry,
.rowRemove {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: none;
  color: var(--text-secondary);
  cursor: pointer;
}
